import AbstractScene from './AbstractScene.js';
import ButtonImageSliced from '../prefabs/ButtonImageSliced.js';


export default class ActiviteA3 extends AbstractScene {
    constructor() {
        super({
            key: "ActiviteA3"
        })
    }
    init(data) {
        this._init(data);
    }

    preload() {
       
        this._preload();
    }


    // update(){

    // }

    create() {
       this.addSounds()
        this.addBackgroundMusique('minimal')
        this.clickSound = this.sound.add('click', { volume: 0.4 });

        this.iframe = document.createElement('iframe');
        this.iframe.src = './assets/iframe/index.html';
        this.UIdom = this.add.dom(this.width / 2, this.height / 2, this.iframe);
        this.style = this.UIdom.node.style;
        this.style.width = 1920 + 'px';
        this.style.height = 1080 + 'px';
        this.style.border = 'none';
        this.style.overflow = 'hidden';

        // this.style.position = 'absolute'; // Assurer que l'iframe est positionné correctement
        // this.style.zIndex = '-1'; // Mettre l'iframe derrière le canvas
        // this.style.pointerEvents = 'none'; // Désactive l'interactivité de l'iframe

        this.UIdom.updateSize();

        window.addEventListener('message', (event) => {
            // Tu peux filtrer ici avec event.origin si besoin
            if (event.data.action === 'goToMenuHome') {
                this.clickSound.play();
                this.scene.start('Menu'); // ou toute autre logique
            }
            if (event.data.action === 'goToMenu') {
                this.clickSound.play();
                if (this.game.data.level === 3) {
                    this.game.data.level = 4
                }
                this.scene.start('Menu'); // ou toute autre logique
            }
            if (event.data.type === 'playSound') {
                this.playSound(event.data.sound);
            } 
        });

        // this.sounds = {
        //     pop: this.sound.add('pop', { volume: 0.1 }),
        //     whoosh: this.sound.add('whoosh', { volume: 0.3 }),
        // };

    }
    // playSound(soundName) {
    //     if (this.sounds[soundName]) {
    //         this.sounds[soundName].play();
    //         console.log('Son joué dans Phaser:', soundName);
    //     }
    // }

}